import script from "./AppTopAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTopAlert.vue?vue&type=script&setup=true&lang=ts"

import "./AppTopAlert.vue?vue&type=style&index=0&id=157d4a3b&lang=scss"

const __exports__ = script;

export default __exports__